var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28868 16.7321L6.72526 19.3515C6.8838 20.3028 7.70683 21 8.6712 21C9.89027 21 10.8176 19.9054 10.6171 18.7029L10.4414 17.6481L6.28868 16.7321Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5C22 14.6421 20.6569 18 19 18C17.3431 18 16 14.6421 16 10.5C16 6.35786 17.3431 3 19 3C20.6569 3 22 6.35786 22 10.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9412 3.67468L5.66196 5.94215C3.52308 6.41397 2 8.30963 2 10.4999C2 12.6902 3.52308 14.5859 5.66196 15.0577L15.9412 17.3252C15.7705 17.0187 15.6194 16.6939 15.486 16.3603C14.8561 14.7856 14.5 12.7129 14.5 10.4999C14.5 8.28689 14.8561 6.21428 15.486 4.63955C15.6194 4.30593 15.7705 3.98115 15.9412 3.67468Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone1);
export default __webpack_public_path__ + "static/media/megaphone-1.457ec258394a8b5c247669d261314521.svg";
export { ForwardRef as ReactComponent };